import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../app-routes";
import "./bread-crumbs.css"
import { Button } from "devextreme-react";
import { useEffect } from "react";
import { usePublicEvents } from "../../contexts/public-events";

export default function BreadCrumbs() {
    const location = useLocation()
    const navigate = useNavigate()

    const {
        publicSaveEvent,
        publicReadOnly,
        publicDirty,
        publicCancelEvent,
        publicAddEvent,
        publicActivePageInfo,
    } = usePublicEvents()


    let currentPath = ""

    const crumbList = location.pathname.split('/').filter(crumb => crumb != '')
    const crumbs = crumbList
        .map((crumb, index) => {
            currentPath += `/${crumb}`
            let pathText = routes
                .find(item => item.path == currentPath)?.pathText ?? crumb
            return (
                <div
                    className="crumb"
                    key={crumb}
                >
                    <Link to={currentPath}>
                        {
                            (publicActivePageInfo && crumbList.length - 1 == index) ?
                                publicActivePageInfo
                                :
                                pathText
                        }
                    </Link>
                </div>
            )
        })
    const crumbs1 = location.pathname
        .split('/')
        .filter(crumb => crumb != '')
        .map(crumb => {
            currentPath += `/${crumb}`
            let pathText = routes
                .find(item => item.path == currentPath)?.pathText ?? crumb
            return (
                <div
                    className="crumb"
                    key={crumb}
                >
                    <Link to={currentPath}>{pathText}</Link>
                </div>
            )
        })

    const goToPreviousPage = () => {
        navigate(-1)
    };

    useEffect(() => { console.log("created breadcrumbs") }, [])

    return (
        <div className="dx-card" style={{ marginInline: "10px", marginTop: "10px", display: "flex", justifyContent: 'space-between' }} >

            <div className="breadcrumbs">

                {publicAddEvent &&
                    <Button
                        text="Ekle"
                        type="normal"
                        // disabled={}
                        visible={publicAddEvent != undefined}
                        onClick={publicAddEvent}
                    />
                }
                {publicSaveEvent &&
                    <Button
                        text="Kaydet"
                        type="success"
                        disabled={!publicDirty}
                        visible={publicSaveEvent != undefined}
                        onClick={publicSaveEvent}
                        
                    />
                }
                {publicCancelEvent &&
                    <Button
                        text="İptal"
                        type="danger"
                        disabled={!publicDirty}
                        visible={publicCancelEvent != undefined}
                        onClick={publicCancelEvent}
                    />
                }


                <span> </span><span> </span>
                {/* <Button
                    className="crumb"
                    key="goToProviousPage"
                    type="normal"
                    onClick={goToPreviousPage}
                    stylingMode="text"
                    text="<< Geri "
                /> */}
                {crumbs}


            </div>
        </div>

    )
}